import React, { FC, ReactNode } from "react";

import { BaseComponentProps, FormatElementId, useThemeColors } from "@keepeek/refront-components";
import { KTheme } from "@keepeek/refront-customers";
import { Box, Grid, useTheme } from "@mui/material";
import clsx from "clsx";

import { Element } from "../../../../models/configuration/pages/element";
import { useConfiguration } from "../../../../providers/config/hooks";
import { useElement } from "../../../../providers/element/hooks";
import { CONFIGURATION_SECTION_PATH } from "../../adminMenu";

export type MediaDetailHeaderTitleLayoutProps = {
  title: ReactNode;
  subtitle: ReactNode;
  sideInfo: ReactNode;
  technicalInfo: ReactNode;
} & BaseComponentProps;

const MediaDetailHeaderTitleLayout: FC<React.PropsWithChildren<MediaDetailHeaderTitleLayoutProps>> =
  function MetadataInfo({ title, subtitle, sideInfo, technicalInfo, className }) {
    const theme = useTheme<KTheme>();
    const pageElementConfig = useConfiguration<Element>(CONFIGURATION_SECTION_PATH.PAGES_ELEMENT);
    const { convertColor } = useThemeColors();
    const { element } = useElement();

    return (
      <Box
        className={clsx("MediaDetailHeaderTitleLayout", className)}
        sx={{
          paddingTop: 2,
          paddingRight: 4,
          paddingBottom: 2,
          paddingLeft: 4,
          backgroundColor:
            convertColor(pageElementConfig?.background?.main) ||
            theme.palette.kElement?.background?.main ||
            theme.palette.grey[100],
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {title}
          </Grid>
          {subtitle && (
            <Grid item xs={12}>
              {subtitle}
            </Grid>
          )}
          {pageElementConfig?.elementId?.identifier && (
            <Grid item xs={12}>
              {<FormatElementId elementIdRules={pageElementConfig?.elementId} element={element} />}
            </Grid>
          )}
          {!!sideInfo && (
            <Grid item xs={12}>
              {sideInfo}
            </Grid>
          )}
          {!!technicalInfo && (
            <Grid item xs={12}>
              {technicalInfo}
            </Grid>
          )}
        </Grid>
      </Box>
    );
  };

export default MediaDetailHeaderTitleLayout;
